// extracted by mini-css-extract-plugin
export default {"container":"highlight-features_container__sP3T4"};